import React from "react";
import { FaGraduationCap, FaBriefcase } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Resume.css";

const Resume = () => {
  return (
    <motion.div
      id="resume"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="-z-0 max-w-full mx-0 px-16 py-8 bg-gradient-to-b from-neutral-50 via-white to-white dark:from-neutral-900 dark:via-neutral-900 dark:to-black rounded-lg shadow-2xl"
    >
      {/* TITLE */}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-5xl font-extrabold text-center mb-12 gradient-text"
      >
        Resume
      </motion.h1>

      {/* Timeline Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Education Section */}
        <motion.section
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold mb-8 text-gray-700 dark:text-gray-300">
            Education
          </h2>

          <div className="space-y-8">
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="relative gradient-border pl-6"
            >
              <div className="absolute -left-4 top-1.5 w-8 h-8 gradient-bg text-white rounded-full flex items-center justify-center shadow-md">
                <FaGraduationCap />
              </div>
              <h3 className="text-xl font-semibold gradient-text">
                Bachelor of Science in Software Engineering
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Arbaminch University, 2021 - 2025
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-700 dark:text-gray-300">
                <li>
                  Completed a Bachelor’s degree in Software Engineering with
                  solid theoretical knowledge and practical development
                  experience.
                </li>
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="relative gradient-border pl-6"
            >
              <div className="absolute -left-4 top-1.5 w-8 h-8 gradient-bg text-white rounded-full flex items-center justify-center shadow-md">
                <FaGraduationCap />
              </div>
              <h3 className="text-xl font-semibold gradient-text">
                Full-Stack Development(MERN Stack)
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Evangadi Tech, 2023
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-700 dark:text-gray-300">
                <li>
                  Completed fullstack development with strong foundation and
                  practica exprience.
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="relative gradient-border pl-6"
            >
              <div className="absolute -left-4 top-1.5 w-8 h-8 gradient-bg text-white rounded-full flex items-center justify-center shadow-md">
                <FaGraduationCap />
              </div>
              <h3 className="text-xl font-semibold gradient-text">
                Data Structure And Algorithm
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                A2SV(Africa To Silicon Valley), 2026 -
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-700 dark:text-gray-300">
                <li>
                  Currently i'm pursuing data structure and algorithm from basic
                  to advanced at A2SV(Africa To Silicon Valley)
                </li>
              </ul>
            </motion.div>
          </div>
        </motion.section>

        {/* Experience Section */}
        <motion.section
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold mb-8 text-gray-700 dark:text-gray-300">
            Experience
          </h2>

          <div className="space-y-8">
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="relative gradient-border pl-6"
            >
              <div className="absolute -left-4 top-1.5 w-8 h-8 gradient-bg text-white rounded-full flex items-center justify-center shadow-md">
                <FaBriefcase />
              </div>
              <h3 className="text-xl font-semibold gradient-text">
                Full-time, IT Officer(Network & Fullstack)
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                G-Power || Five-Star Elevator Manufacturing PLC, 2025 - Present
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-700 dark:text-gray-300">
                <li>
                  Designing, developing, and maintaining full-stack web
                  applications to support internal systems and business
                  operations.
                </li>
                <li>
                    Supporting senior IT staff to Configure and monitor network
                    systems, ensuring secure and reliable IT infrastructure. Also working on system support 
                  
                </li>
                <li>
                  Implemented performance optimizations and best practices,
                  improving system speed, stability, and user experience.
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="relative gradient-border pl-6"
            >
              <div className="absolute -left-4 top-1.5 w-8 h-8 gradient-bg text-white rounded-full flex items-center justify-center shadow-md">
                <FaBriefcase />
              </div>
              <h3 className="text-xl font-semibold gradient-text">
                Part-time, Full-Stack Developer
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Wara Technology, 2024 - Present
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-700 dark:text-gray-300">
                <li>
                  Working as a fullstack developer by developing scalable web
                  applications and Systems
                </li>
                <li>
                  Collaborated with cross-functional teams to deliver
                  high-quality software.
                </li>
                <li>
                  Implemented performance optimizations, improving app speed
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="relative gradient-border pl-6"
            >
              <div className="absolute -left-4 top-1.5 w-8 h-8 gradient-bg text-white rounded-full flex items-center justify-center shadow-md">
                <FaBriefcase />
              </div>
              <h3 className="text-xl font-semibold gradient-text">
                Paid Intern - Full-Stack Developer
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Athlete Kenenisa Bekele Polythechnic College, Summer 2024
              </p>
              <ul className="list-disc list-inside mt-4 text-gray-700 dark:text-gray-300">
                <li>
                  Designed, developed and deployed Student Registrar System for
                  the College
                </li>
                <li>
                  Worked closely with College Dean, Managers and department
                  Supervisors.
                </li>
                <li>Got Appreciation Certificate upon completion</li>
              </ul>
            </motion.div>
          </div>
        </motion.section>
      </div>
    </motion.div>
  );
};

export default Resume;
